'use strict';
import {getOrganization} from '../../app/model/reducers/state';
import {getId} from '../../core-utilities/domain/ReduxUtils';


module.exports = [
  '$modal',
  '$scope',
  '$document',
  '$ngRedux',
  'OrganizationDomain',
  'FormDomain',
  'FormSelectorFilterMixin',
  'currentValue',
  'currentFilter',
  FormSelectorPanelController];

function FormSelectorPanelController(
  $modal,
  $scope,
  $document,
  $ngRedux,
  OrganizationDomain,
  FormDomain,
  FormSelectorFilterMixin,
  currentValue,
  currentFilter,
) {
  const vm = $scope.selector = {
    onSelect: onSelect,
    cancel: cancel,
    currentValue: currentValue,
  };
  const filterService = FormSelectorFilterMixin(vm, $scope, currentFilter);

  filterService.initFiltering(loadList());

  function loadList() {
    return OrganizationDomain.$getFormsRelations(getId(getOrganization($ngRedux.getState())));
  }

  function onSelect(result) {
    $document[0].getElementById("search-filter").blur();
    FormDomain.$get(getId(result)).then(function (form) {
      $modal.hide(form);
    });
  }

  function cancel() {
    $document[0].getElementById("search-filter").blur();
    $modal.cancel();
  }
}



// WEBPACK FOOTER //
// ./src/js/forms/selector/FormSelectorPanelController.js